    <script>
    export let map;
    export let mainBgColorControls;
    export let mainDrawColor;
    export let mainBorderColor;
    export let mainSpecialColor;
    export let config;
    export let borderWidthButtons;
    export let boxShadow;
    export let darkMode;

    
    let minFilter;
    // $: testNumber = 0;
        
    function walkingDistance(minutes) {
        const meters = 80 * minutes
        return meters
    }

    function filterMap(minutes) {
        map.setFilter("h3-hexes-layer",    
            [
            'all', 
            ["<=", ['get', 'accessibilityRawDist'], walkingDistance(minutes)]//,
            // ["<=", ['get', 'accessibilityRawDist'], normToDistance(+end)]
        ]
        )
        // map.setPaintProperty(
        //     'h3-hexes-layer', 
        //     'heatmap-color', [
		// 					'interpolate',
		// 					['linear'],
		// 					['heatmap-density'],
		// 					0, 'rgba(236,222,239,0)',
		// 					// 0.005, config.colorScale[1],
		// 					0.1, "red",
		// 					0.2, "red",
		// 					// 0.2, 'rgba(236,222,239,0)',
		// 					0.3, "red",
		// 					0.4, "red",
		// 					0.5, "red",
		// 					0.6, "red",
		// 					0.7, "red",
		// 					0.9, "red",
		// 					1, "red"]
        // );

        // map.setPaintProperty('h3-hexes-layer', 'heatmap-weight', 1)
			  
    }

    function resetMap() {
        map.setFilter("h3-hexes-layer",    
            [
            'all', 
            [">=", ['get', 'accessibilityRawDist'], 0]//,
            // ["<=", ['get', 'accessibilityRawDist'], normToDistance(+end)]
        ]
        )
        // map.setPaintProperty(
        //     'h3-hexes-layer', 
        //     'heatmap-color', [
		// 					'interpolate',
		// 					['linear'],
		// 					['heatmap-density'],
		// 					0, 'rgba(236,222,239,0)',
		// 					// 0.005, config.colorScale[1],
		// 					0.1, config.colorScale[1],
		// 					0.2, config.colorScale[2],
		// 					// 0.2, 'rgba(236,222,239,0)',
		// 					0.3, config.colorScale[3],
		// 					0.4, config.colorScale[4],
		// 					0.5, config.colorScale[5],
		// 					0.6, config.colorScale[6],
		// 					0.7, config.colorScale[7],
		// 					0.9, config.colorScale[8],
		// 					1, config.colorScale[9]]
        // );

        // map.setPaintProperty('h3-hexes-layer', 
        //                     'heatmap-weight', {
		// 					'property': 'accessibility',
		// 					'type': 'exponential',
		// 					'stops': [
		// 						[0, 0.1],
		// 						[0.3, 0.1],
		// 						[1, 1]
		// 					]
		// 				}
        // )
				// source = map.getSource(sourceId);
			  
    }
        
    </script>
    <p style="margin-bottom:0px;margin-top:8px">Filter for areas where services are available within a <!--
 --><input 
    type="text" 
    bind:value={minFilter}
    placeholder="0"
    style="background-color: {mainBgColorControls};
            color: {mainDrawColor};
            border: {borderWidthButtons}px solid {mainBorderColor};
            box-shadow: {darkMode===true?"none":boxShadow};"/> min. walk <!--
 --><button 
    type="submit" 
    on:click={()=>{filterMap(minFilter)}}
    style="background-color: {mainBgColorControls};
            color: {mainDrawColor};
            border: {borderWidthButtons}px solid {mainBorderColor};
            box-shadow: {darkMode===true?"none":boxShadow};
            margin-right:2px">
                save
    </button><!--
 --><button 
    type="submit" 
    on:click={()=>{
        minFilter = 0
        resetMap()
        }}
    style="background-color: {mainBgColorControls};
            color: {mainDrawColor};
            border: {borderWidthButtons}px solid {mainBorderColor};
            box-shadow: {darkMode===true?"none":boxShadow};">
    reset</button>
    </p>
    <!-- {accessFilter}<br>
    {testNumber}
     -->

    <style>
        input {
        width:25px;
        /* height:15px; */
        text-align: center;
        font-size:12px;
        }

        button {
        font-size:10px;
		/* max-width: 200px; */
		margin-bottom: auto;
		margin-left: 0px;
		text-transform: uppercase;
		cursor: pointer;
		/* font-size: 10px; */
	}
    </style>
    
    